import React, { Component } from 'react';
import 'whatwg-fetch';
class getRegistre extends Component {
  constructor(){
    super();
    const min = 0;
    const max = 9;
    const rand_1 = min + parseInt(Math.random() * (max - min))
    const rand_2 = min + parseInt(Math.random() * (max - min))
    const rand_3 = min + parseInt(Math.random() * (max - min))
    const rand_4 = min + parseInt(Math.random() * (max - min))
    const final =rand_1+""+rand_2+""+rand_3+""+rand_4

    this.state = {
        nombre:'',
        msg:'',
        numero_telefono:'',
        codigo_validacion: '',
        codigo_enviado:'',
        segundo:0,
        final,
        contador:0,
        anio:'',
        validate_anio:false,
        anio_text:''
    }
  }
  componentWillUnmount () {
    clearInterval(this.timer)
  }
  /*validateEmail = (email) => {
      return /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(email)
  }*/
  validateTelefono = (telefono) => {
      return /^[0][7-9][0-9]{8}$/.test(telefono)
  }
  validateAnio = (anio) => {
      return /^[0-9]{4}$/.test(anio)
  }
   tick () {
     let segundo = this.state.segundo
     segundo++
     if(segundo===31){
       clearInterval(this.timer)
       return null
     }
     this.setState({
       segundo
     })
   }
  startTimer () {
    clearInterval(this.timer)
    this.timer = setInterval(this.tick.bind(this), 1000)
  }
  getValiteAnio =()=>{
    const anio = this.state.anio
    const anio_text = this.state.anio_text
    if(anio_text.trim()===''){
      this.setState({
        msg : "Ingrese Año"
      })
      return
    }
    if(!this.validateAnio(anio_text)){
      this.setState({
        msg : "Ingrese Año"
      })
      return
    }
    if(Number(anio_text)>1900&&Number(anio_text)<2021){

    }else{
      this.setState({
        msg : "Año de Nacimiento Incorrecto; Ej 1999"
      })
      return
    }
    if(anio.trim()===''){
      this.getValite()
      return
    }

    if(anio && anio_text){
      if(Number(anio)>0&&Number(anio_text)>0){
        if(Number(anio)===Number(anio_text)){
          this.getValite()
        }else{
          this.setState({
            msg : 'No coincide Año de Nacimiento'
          })
        }
      }else{
        this.setState({
          msg : 'Ingrese Año de Nacimiento'
        })
      }
    }else{
      this.setState({
        msg : 'Ingrese Año de Nacimiento'
      })
    }
  }
  getValiteCodigoTelefono =()=>{
    const codigo_enviado = this.state.codigo_enviado
    const codigo_validacion = this.state.codigo_validacion
    if(codigo_enviado && codigo_validacion){
      if(Number(codigo_enviado)>0&&Number(codigo_validacion)>0){
        if(Number(codigo_enviado)===Number(codigo_validacion)){
          //this.getValite()
          this.setState({
            validate_anio : true,
            msg:'',
            anio: ''
          })
        }else{
          this.setState({
            msg : 'No coincide código'
          })
        }
      }else{
        this.setState({
          msg : 'No coincide código'
        })
      }
    }else{
      this.setState({
        msg : 'Ingrese código'
      })
    }
  }
  getValiteTelefono =()=>{
    const numero_telefono = this.state.numero_telefono.trim()
    const nombre = this.state.nombre.trim()

    if(nombre.trim()===''){
      this.setState({
        msg : "Ingrese Nombre"
      })
      return
    }
    if(this.validateTelefono(numero_telefono)){
      if(Number(this.state.contador)<2){
        const final = this.state.final
        const database = this.props.database
        const url= "https://www.grupomn.net/neola/index.php/SMS/getSMS/"+numero_telefono+"/"+final+"/GMN2019/"+database;
        var obj = { accion:'findpendiente'};
        fetch(url, {
          method: 'POST',
          body: JSON.stringify(obj),
          headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(res => res.json())
        .then((data) => {
          //console.log(data)
          if(data.message.includes('OK:')){
            this.setState({
              codigo_enviado : final,
              msg : '',
              segundo: 0,
              contador: Number(this.state.contador)+1
            },()=>{
              this.props.get_loading(false)
            })
            this.startTimer()
          }else{
            if(data.message.includes('BAN:')){
              this.setState({
                msg : "Su Número está Baneado, Favor Llamar al "+this.props.telefono_contacto
              },()=>{
                this.props.get_loading(false)
              })
            }else{
              if(data.message.includes('NEXT:')){
                 //this.getValite();
                 this.setState({
                   validate_anio : true,
                   msg:'',
                   anio: data.anio
                 },()=>{
                   this.props.get_loading(false)
                 })
              }else{
                this.setState({
                  msg : "Error de Código"
                },()=>{
                  this.props.get_loading(false)
                })
              }
            }
          }

        })
        .catch(console.log)
        this.props.get_loading(true)
        }else{
          this.setState({
            msg : "Intento Fallido de SMS: Favor Llamar al "+this.props.telefono_contacto,
            segundo: 0
          })
        }
      }else{
        this.setState({
          msg : "Número Incorrecto, Ejemplo: 0987654321"
        })
      }

  }
  getValite =()=>{

    const nombre = this.state.nombre.trim()
    const numero_telefono = this.state.numero_telefono.trim()
    const anio = this.state.anio_text
    if(nombre.trim()===''){
      this.setState({
        msg : "Ingrese Nombre"
      })
      return
    }
    if(numero_telefono.trim()===''){
      this.setState({
        msg : "Ingrese Celular"
      })
      return
    }
    const url= this.props.dir_url + "webapp/getNewUser";
    const token =  this.props.token
    const codigo = numero_telefono
    var obj = { accion:'new', token, nombre,codigo,anio};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.props.get_loading(false)
        this.props.setTokenClient(data[0].msg)
      }else {
        this.setState({
          msg : data[0].msg
        },()=>{
          this.props.get_loading(false)
        })
      }
    })
    .catch(console.log)
    this.props.get_loading(true)
  }

  inputChangedHandlerText1 = (event) => {
    this.setState({
      nombre :event.target.value
    })
  }

  inputChangedHandlerText2= (event) => {
    this.setState({
      anio_text :event.target.value
    })
  }

  inputChangedHandlerText4 = (event) => {
    this.setState({
      numero_telefono :event.target.value
    })
  }
  inputChangedHandlerText5 = (event) => {
    this.setState({
      codigo_validacion :event.target.value
    })
  }

  render() {
    const codigo_enviado = this.state.codigo_enviado
    const validate_anio = this.state.validate_anio
    let modulo
    if(validate_anio===false){
      modulo =<div className="cssversion_menu cssversion_colorblanco">
        <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_go_to('')} />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentRight">

          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter" style={{"display":"flex"}}>
          <span className="span-global-title">Regístrate</span>
        </div>
        <div className="cssversion_pw100">
          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') } />
            </div>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            </div>
            <div className="cssversion_pw70 cssversion_pxh50 cssversion_contentCenter">
              {(codigo_enviado)?
                <span className="span-global">{this.state.nombre}</span>
                :
                <input value={this.state.nombre} onChange={(event)=>this.inputChangedHandlerText1(event)} className="input-global cssversion_pw90" placeholder="Nombre" />
               }
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15443912291582004495-128.png') } />
            </div>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
                 <span className="span-global">+{593}</span>
            </div>
            <div className="cssversion_pw70 cssversion_pxh50 cssversion_contentCenter">
              {(codigo_enviado)?
                <span className="span-global">{this.state.numero_telefono}</span>
                :
                <input value={this.state.numero_telefono} onChange={(event)=>this.inputChangedHandlerText4(event)} className="input-global cssversion_pw90" placeholder="Celular Ej: 0987654321" />
              }
            </div>
          </div>
          {(codigo_enviado)?
            <React.Fragment>
              <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
                <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
                   <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15443912291582004495-128.png') } />
                </div>
                <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
                  <input value={this.state.codigo_validacion} onChange={(event)=>this.inputChangedHandlerText5(event)} className="input-global cssversion_pw90" placeholder="Ingrese Código de Validación" />
                </div>
              </div>
            </React.Fragment>
          :''}
          <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter">
            {(codigo_enviado)?
              <button className="button-global cssversion_pw85" onClick={ () => this.getValiteCodigoTelefono()}>
                Validar y Registrase
              </button>
            :
              <button className="button-global cssversion_pw85" onClick={ () => this.getValiteTelefono()}>
                Enviar Código por SMS
              </button>
            }
          </div>
          <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter">
            {(this.state.msg)?
            <div className="cssversion_pw85 cssversion_pxh40 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
              <span className="span-global-link" style={{"color":"white"}}>{this.state.msg}</span>
            </div>
            :''}
          </div>
          <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter">
            {(this.state.segundo)?
              <React.Fragment>
               {(Number(this.state.segundo)===30)?
                <div onClick={()=>this.getValiteTelefono()} className="cssversion_pw85 cssversion_pxh40 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
                  <span className="span-global-link" style={{"color":"white"}}>Click para volver a enviar SMS</span>
                </div>
                :
                <div className="cssversion_pw85 cssversion_pxh40 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
                  <span className="span-global-link" style={{"color":"white"}}>Favor esperar el SMS, {this.state.segundo} segundos</span>
                </div>}
              </React.Fragment>
            :''}
          </div>
        </div>
      </div>
    }else{
      modulo =<div className="cssversion_menu cssversion_colorblanco">
        <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_go_to('')} />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentRight">

          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter" style={{"display":"flex"}}>
          {(this.state.anio)?
          <span className="span-global-title">Validar Año de Nacimiento</span>
          :
          <span className="span-global-title">Ingrese Año de Nacimiento</span>
          }
        </div>
        <div className="cssversion_pw100">
          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') } />
            </div>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            </div>
            <div className="cssversion_pw70 cssversion_pxh50 cssversion_contentCenter">
              <input value={this.state.anio_text} onChange={(event)=>this.inputChangedHandlerText2(event)} className="input-global cssversion_pw90" placeholder="Año Nacimiento: Ej 1999" />
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter">
             <button className="button-global cssversion_pw85" onClick={ () => this.getValiteAnio()}>
                Continuar
              </button>
          </div>
          <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter">
            {(this.state.msg)?
            <div className="cssversion_pw85 cssversion_pxh40 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
              <span className="span-global-link" style={{"color":"white"}}>{this.state.msg}</span>
            </div>
            :''}
          </div>
        </div>
      </div>
    }

    return (
      modulo
    )
  }
}
/*<span className="span-global-link" onClick={ () => this.props.get_go_to('login_session')}>Iniciar sesión</span>*/
export default getRegistre
